import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { MobileLeadFormSection } from '@/components/property-detail/mobile/MobileLeadFormSection';
import { ListingType } from '@/lib/tracking';

interface EmailContactDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  agentName?: string;
  agencyName?: string;
  agentLogo?: string | null;
  phoneNumber?: string;
  referenceId: string;
  propertyId?: string;
  projectId?: string;
  listingId?: string;
  listingType?: ListingType;
}

export function EmailContactDialog({
  open,
  onOpenChange,
  agentName = 'Property Agent',
  agencyName,
  agentLogo,
  phoneNumber,
  referenceId,
  propertyId,
  projectId,
  listingType,
}: EmailContactDialogProps) {
  const id = propertyId || projectId || '';
  const kind: 'property' | 'project' = projectId && !propertyId ? 'project' : 'property';

  const propertyShim = {
    contact_phone: phoneNumber,
    contact_person: agentName,
    agency_name: agencyName,
    agency_logo_url: agentLogo,
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-md p-0 gap-0 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <DialogHeader className="px-4 pt-4">
          <DialogTitle className="sr-only">Contact Agent</DialogTitle>
        </DialogHeader>
        <div className="p-2">
          <MobileLeadFormSection
            listingId={id}
            listingLabel={listingType || kind}
            referenceCode={referenceId}
            listingKind={kind}
            property={propertyShim}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
